export default "__VITE_ASSET__7abb460e__"